const editEvents = {
    timeSlot: 'deliveryRibbonEditTimeSlot',
    fulfilmentMethod: 'deliveryRibbonEditFulfilmentMethod',
};

class HeaderDeliveryRibbonController {
    constructor(
        $window,
        $location,
        settings,
        fulfilmentService,
        shopPageStateService,
        fulfilmentWizardService,
        breakpointsService,
        localStorageWrapper,
    ) {
        this.$window = $window;
        this.$location = $location;
        this.settings = settings;
        this.fulfilmentService = fulfilmentService;
        this.shopPageStateService = shopPageStateService;
        this.fulfilmentWizardService = fulfilmentWizardService;
        this.breakpointsService = breakpointsService;
        this.localStorageWrapper = localStorageWrapper;
    }

    $onInit() {
        this.fulfilmentOptions = this.fulfilmentService.fulfilmentOptions;
        this.fulfilmentSteps = this.fulfilmentService.fulfilmentSteps;

        this.displayAddress = this.getAddress();
        this.displayTimeSlot = this.getTimeSlot();
        this.deliveryType = this.fulfilmentService.selectedFulfilmentMethod.type;
        this.hasSelectedAddress = !!this.fulfilmentService.savedAddress;

        setTimeout(() => this.sendEditEventOnLoad());
    }

    getTimeSlot() {
        if (!this.hasSelectedTimeSlot()) {
            return 'Available items may change';
        }

        if (
            this.fulfilmentService.reservedDate &&
            !this.fulfilmentService.isExpress
        ) {
            return `${this.fulfilmentService.reservedDate.DateText}, ${this.fulfilmentService.reservedTime.TimeWindow}`;
        }

        return this.fulfilmentService.reservedTime.TimeWindow;
    }

    getAddress() {
        if (!this.fulfilmentService.savedAddress) {
            return 'Set your Delivery address';
        }

        if (this.fulfilmentService.selectedFulfilmentMethod === this.fulfilmentOptions.pickup) {
            return this.fulfilmentService.savedAddress.AddressText;
        }
        return this.fulfilmentService.savedAddress.AddressText;
    }

    showTimeSlotLoading() {
        return (
            this.fulfilmentWizardService.currentStep ===
                this.fulfilmentSteps.timeslot && this.fulfilmentWizardService.timeTableLoading
        );
    }

    hasSelectedTimeSlot() {
        return this.fulfilmentWizardService.hasSelectedTimeslot();
    }

    editFulfilmentMethod() {
        this.openSideCart(editEvents.fulfilmentMethod);
        this.fulfilmentWizardService.editFulfilmentMethod();
    }

    editTimeSlot() {
        if (!this.hasSelectedAddress) {
            this.openSideCart(editEvents.fulfilmentMethod);
            this.fulfilmentWizardService.editFulfilmentMethod();
        } else {
            this.openSideCart(editEvents.timeSlot);
            this.fulfilmentWizardService.editTimeSlot();
        }
    }

    sendEditEventOnLoad() {
        if (this.localStorageWrapper.get(editEvents.timeSlot)) {
            this.localStorageWrapper.remove(editEvents.timeSlot);
            this.fulfilmentWizardService.editTimeSlot();
        }

        if (this.localStorageWrapper.get(editEvents.fulfilmentMethod)) {
            this.localStorageWrapper.remove(editEvents.fulfilmentMethod);
            this.fulfilmentWizardService.editFulfilmentMethod();
        }
    }

    openSideCart(event) {
        const cartUri = '/shop/cart';

        if (this.breakpointsService.isInGreaterThanMediumFormatLandscape || this.$location.path() === cartUri) {
            this.shopPageStateService.isCartOpen = true;
        } else {
            this.localStorageWrapper.set(event, true);
            this.$window.location.href = cartUri;
        }
    }
}

HeaderDeliveryRibbonController.$inject = [
    '$window',
    '$location',
    'Settings',
    'FulfilmentService',
    'ShopPageStateService',
    'FulfilmentWizardService',
    'BreakpointsService',
    'LocalStorageWrapper',
];

const headerDeliveryRibbonComponentDefinition = {
    controller: HeaderDeliveryRibbonController,
    template: require('./header-delivery-ribbon.component.html').trim(),
};

module.exports = {
    HeaderDeliveryRibbonController,
    headerDeliveryRibbonComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/header/header-delivery-ribbon/header-delivery-ribbon.component.js